<template>
  <a
    class="email-edit--button"
    :class="{hide: !editing}"
    @click="editClick()"
    @keyup.enter="editClick()"
  >
    <span class="email-edit__link">{{ text }}</span>
    <div class="button--secondary button--icon ">
      <svgicon
        name="Controls/Edit"
      />
    </div>
  </a>
</template>

<script>
export default {
  name: 'EditButton',
  props: {
    editing: {
      type: Boolean,
      default: false
    },
    text: {
      type: String,
      default: 'Ändra'
    }
  },
  data () {
    return {
      edit: 'Ändra',
      abort: 'Avbryt'
    }
  },
  methods: {
    editClick () {
      this.$emit('toggleEdit')
    }
  }
}
</script>

<style lang='scss'>
.email-edit__link {
  text-transform: none;
  margin-left: 0.5rem;
  color: $color-primary-cta;

  @include font(text, 2, "bold");

  @include media-breakpoint-up(md) {
    margin-right: 0.5rem;
    margin-left: 0;
  }
}

.email-edit--button {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: 1rem;
  flex-direction: row-reverse;
  transition: all 100ms ease-in-out;
  text-decoration: none;

  &:hover {
    .email-edit__link {
      color: $color-pink-light;
    }

    div.button--icon {
      background: $color-pink-light;
      fill: $color-white;
    }
  }

  @include media-breakpoint-up(md) {
    flex-direction: row;
    justify-content: flex-start;
  }

  &.hide {
    display: none;
  }

  @include media-breakpoint-up(md) {
    justify-content: flex-end;
    margin-top: 0;
  }
}
</style>
